import ButtonV2 from "@/components/ButtonV2";
import { useCardAnimation } from "@/hooks/useCardAnimation";
import Image from "next/image";
import type { ProductDeal } from "./BlockchainPayment";

type PricingCardProps = {
  deal: ProductDeal;
  isConnected: boolean;
  show?: () => void;
  buyAgent: (deal: ProductDeal, isConnected: boolean, show?: () => void) => void;
};

const PricingCard = ({ deal, isConnected, show, buyAgent }: PricingCardProps) => {
  const { handleMouseMove, handleMouseLeave } = useCardAnimation();
  const isHalfPrice = deal === "half-price";

  return (
    <div
      // biome-ignore lint/a11y/useSemanticElements: no need
      role="button"
      tabIndex={0}
      onClick={() => buyAgent(deal, isConnected, show)}
      onKeyDown={(e) => e.key === "Enter" && buyAgent(deal, isConnected, show)}
      onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
      onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
      className={`mt-5 p-9 pt-11 rounded-3xl w-full cursor-pointer transition-all duration-200 ease-out will-change-transform hover:shadow-xl relative ${
        isHalfPrice
          ? "bg-gradient-to-r from-turquoise via-[#97B1FF] to-turquoise text-white gradient bg-[length:400%_400%] bg-[position:0%_50%] transition-[transform,background-position]"
          : "bg-white text-black"
      }`}
    >
      {isHalfPrice && (
        <div className="absolute top-3 -right-2 bg-red-500 text-white px-4 py-1 rounded-l-full transform font-bold shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)]">
          Pay in $KOLZ & Save 50%
        </div>
      )}
      <h3 className="text-3xl font-semibold mb-6 text-center">AI-Powered KOL</h3>
      <div className="flex items-end gap-2 text-5xl font-semibold justify-center">
        <div className="flex items-center gap-2">
          {isHalfPrice ? "0.5" : "1"} <Image src="/eth.svg" alt="eth" height={20} width={20} />
        </div>{" "}
        <span className={`text-lg ${isHalfPrice ? "text-white/60" : "text-black/30"}`}>/ Agent</span>
      </div>
      {isHalfPrice && <p className="text-white/60 text-center text-sm font-semibold">paid in $KOLZ tokens</p>}
      <ul className={`${isHalfPrice ? "my-6" : "mb-6 mt-[38px]"} list-[square] ml-3`}>
        <li>One time payment, no other hidden setup fees</li>
        <li>
          Expand your AI network for <span className="font-semibold">0.5 ETH per additional KOL</span>
        </li>
      </ul>

      <ButtonV2
        onClick={(e) => {
          e.stopPropagation();
          buyAgent(deal, isConnected, show);
        }}
        size="lg"
        color={isHalfPrice ? "secondary-inverse" : "primary"}
        className="w-full"
      >
        Get started
      </ButtonV2>
    </div>
  );
};

export default PricingCard;
